import React, { lazy, Suspense } from "react";

import { FieldPath, FieldValues } from "react-hook-form";

import { PhoneInputProps } from "@/components/atoms/Form/PhoneNumberInput/MuiPhoneNumberInput";

import LoadingInput from "../LoadingInput/LoadingInput";

const MuiPhoneNumberInput = lazy(() => import("./MuiPhoneNumberInput"));

const PhoneNumberInput = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
    props: PhoneInputProps<TFieldValues, TName>,
): React.ReactElement => (
    <Suspense fallback={<LoadingInput />}>
        {/*@ts-ignore*/}
        <MuiPhoneNumberInput {...props} />
    </Suspense>
);

export default PhoneNumberInput;
